<template>
    <div class="cadre">
        <h3>Relance client</h3>
        <table>
            <thead>
                <tr>
                    <th>Nom</th>
                    <th>Prenom</th>
                    <th>Gsm</th>
                    <th>Date Dernière Commande</th>
                    <th>Date Dernière Livraison</th>
                    <th></th>
                </tr>

            </thead>
            <tbody v-if="clients && clients.length">
                <tr v-for="(client, index) in paginatedItems" :key="client.id">
                    <td>{{ client.nom }}</td>
                    <td>{{ client.prenom }}</td>
                    <td>{{ getCoordonnee('GSM', client.coordonnee) }}</td>
                    <td>{{ this.format(client.derniereCommande.dateCreation) }}</td>
                    <td>{{ client.derniereCommande?.livraison?.dateLivraison ? this.format(client.derniereCommande.livraison.dateLivraison) : '-' }}</td>                    <td>
                        <div class="tab_outils">
                            <div>
                                <a v-on:click="editClient(client.id)">
                                    <i class="material-icons"
                                        style="font-size:20px;color: cornflowerblue">visibility</i>
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tfoot v-else>
                <tr>
                    <td colspan="5" class="emptyTableMessage">Aucun client trouvé</td>
                </tr>
            </tfoot>
        </table>
        <div class="pagination">
            <a v-on:click="previousPage()" :disabled="currentPage === 1">
                <i class="material-icons" style="font-size:24px;">keyboard_double_arrow_left</i>
            </a>
            <span>Page {{ currentPage }} sur {{ totalPages }}</span>
            <a v-on:click="nextPage()" :disabled="currentPage === totalPages">
                <i class="material-icons" style="font-size:24px;">keyboard_double_arrow_right</i>
            </a>
        </div>
    </div>

</template>

<script>
import Axios from '@/services/axios.service';
import DateFormatService from '@/services/dateFormat.service';
import PaginationService from '@/services/pagination.service';
import ClientEdit from '../../signaletique/client/ClientEdit.vue';

export default {
    name: 'RelanceIndex',
    mixins: [PaginationService,DateFormatService],
    components: {
        ClientEdit,
    },
    data() {
        return {
            clients: [],
            clientEditId: null,
        };
    },
    props: {
        msg: String
    },
    mounted() {
        this.fetchRelance();
    },
    methods: {
        fetchRelance() {
            Axios.get('/identite')
                .then(res => {
                    const listeFiltree = this.filtersByForm(res.data);
                    this.items = listeFiltree;
                    this.clients = listeFiltree;
                })
                .catch(err => {
                    console.error('Erreur lors du chargement des clients :', err);
                });
        },
        filtersByForm(data) {
            const anneeDerniere = new Date().getFullYear() - 1;
            return data
                .map(client => {
                    // filtrer les commandes de cette année
                    const commandesCetteAnnee = client.commande.filter(
                        cmd => new Date(cmd.dateCreation).getFullYear() === anneeDerniere
                    );

                    if (!commandesCetteAnnee.length) return null;

                    // trouver la dernière commande (la plus récente)
                    const derniereCommande = commandesCetteAnnee.reduce((prev, curr) => {
                        return new Date(prev.dateCreation) > new Date(curr.dateCreation) ? prev : curr;
                    });

                    return {
                        ...client,
                        derniereCommande
                    };
                })
                .filter(client => client !== null)
                // trier par date de dernière commande (de la plus vieille à la plus récente)
                .sort((a, b) => new Date(a.derniereCommande.dateCreation) - new Date(b.derniereCommande.dateCreation));
        },
        editClient(id) {
            this.$router.push({ name: 'clientInfo', params: { id } })
        },
        getCoordonnee(type, coordonnee) {
            if (Array.isArray(coordonnee)) {
                const coord = coordonnee.find(c => c.typeCoordonnee === type);
                return coord ? coord.information : null;
            }
            return null;
        },
    }
}

</script>

<style></style>